<template>
  <transition name="fade-right" appear>
    <div v-if="showing" class="nan-banner bg-white px-3 py-2">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    showing: Boolean
  }
};
</script>

<style lang="scss">
.nan-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  left: 0;
  border: 1px solid #e3e8ec;
  z-index: 1030;
}
</style>
